import { useTranslation } from 'react-i18next';
import { Github, Linkedin, Mail, ArrowUp, Heart } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const Footer = () => {
  const { t } = useTranslation();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const socialLinks = [
    {
      icon: Github,
      href: 'https://github.com/eminniftili',
      label: 'GitHub',
    },
    {
      icon: Linkedin,
      href: 'https://www.linkedin.com/in/eminniftili',
      label: 'LinkedIn',
    },
    {
      icon: Mail,
      href: 'mailto:eminiftiyev23@gmail.com',
      label: 'Email',
    },
  ];

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0F172A] border-t border-[#22D3EE]/20 py-12"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex flex-col items-center space-y-6">
          {/* Social Links */}
          <div className="flex items-center space-x-4">
            {socialLinks.map((social) => {
              const Icon = social.icon;
              return (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`social-link-${social.label.toLowerCase()}`}
                  className="p-3 rounded-full bg-[#1A1F3A] border border-[#22D3EE]/30 text-[#22D3EE] hover:bg-[#22D3EE] hover:text-[#0A0E27] hover:shadow-[0_0_20px_rgba(34,211,238,0.3)] transition-all duration-300"
                  aria-label={social.label}
                >
                  <Icon className="w-5 h-5" />
                </a>
              );
            })}
          </div>

          {/* Copyright */}
          <div className="text-center space-y-2">
            <p className="text-[#CBD5E1] text-sm flex items-center justify-center space-x-2">
              <span>{t('footer.made_with')}</span>
              <Heart className="w-4 h-4 text-[#EF4444] fill-current" />
              <span>by Emin Hasanov</span>
            </p>
            <p className="text-[#94A3B8] text-xs">
              © {new Date().getFullYear()} Emin Hasanov. {t('footer.rights')}.
            </p>
          </div>

          {/* Back to Top Button */}
          <Button
            onClick={scrollToTop}
            data-testid="back-to-top-button"
            className="px-6 py-3 rounded-full bg-gradient-to-r from-[#22D3EE] to-[#14B8A6] text-[#0A0E27] font-semibold hover:shadow-[0_0_30px_rgba(34,211,238,0.5)] hover:scale-105 transition-all duration-300"
          >
            <ArrowUp className="w-4 h-4 mr-2" />
            {t('footer.back_to_top')}
          </Button>
        </div>
      </div>
    </footer>
  );
};
